import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useUpdateSolicitudGastosTransporteByID = () => {
  const [loadingUpdateSolicitudGastosTransporteById, setLoadingUpdateSolicitudGastosTransporteById] = useState(false);
  const [successUpdateSolicitudGastosTransporteById, setSuccessUpdateSolicitudGastosTransporteById] = useState(false);
  const [errorUpdateSolicitudGastosTransporteById, setErrorUpdateSolicitudGastosTransporteById] = useState(null);
  const [dataUpdateSolicitudGastosTransporteById, setDataSolicitudGastosTransporte] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const updateSolicitudGastosTransporteById = async (
    userId: string,
    formId: string,
    data: any,
    _cb?: (data: any) => void
  ) => {
    setLoadingUpdateSolicitudGastosTransporteById(true);
    setSuccessUpdateSolicitudGastosTransporteById(false);
    setErrorUpdateSolicitudGastosTransporteById(null);

    try {
      const payload = {
        ...data,
        Id: data?.Id ?? formId,
        UsuarioId: data?.UsuarioId ?? userId,
      };
      const res = await apiRecord.updateSolicitudGastosContingenciaProfesionalTransporteByID(userId, formId, payload);

      setSuccessUpdateSolicitudGastosTransporteById(true);
      setDataSolicitudGastosTransporte(res.data);
      _cb?.(res.data);

      return res.data;
    } catch (err: any) {
      console.error("Error en updateSolicitudGastosTransporteById:", err);
      setErrorUpdateSolicitudGastosTransporteById(err.response?.data ?? err);

      throw err;
    } finally {
      setLoadingUpdateSolicitudGastosTransporteById(false);
    }
  };

  return {
    updateSolicitudGastosTransporteById,
    loadingUpdateSolicitudGastosTransporteById,
    successUpdateSolicitudGastosTransporteById,
    errorUpdateSolicitudGastosTransporteById,
    dataUpdateSolicitudGastosTransporteById
  };
};

export default useUpdateSolicitudGastosTransporteByID;
